import styled from 'styled-components';

export default styled.div`
    .coins {
        margin-bottom: var(--spacing-8);
    }
`;
